import { render } from "./TextAreaInput.vue?vue&type=template&id=39c94416&scoped=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"

import "./TextAreaInput.vue?vue&type=style&index=0&id=39c94416&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c94416"]])

export default __exports__